import styles from './FJAIAudioItem.module.less';
import FJAutoLoading from '../../../../common/components/FJLoading/FJAutoLoading.jsx';
import FJErrorIcon from '../../../../assets/svg/error.svg?react';
import FJPlayIcon from '../../../../assets/svg/play.svg?react';
import FJPauseIcon from '../../../../assets/svg/pause.svg?react';
import FJLocalStore from '../../../../store/FJLocalStore.js';
import FJButton from '../../../../common/components/FJButton/FJButton.jsx';
import EditIcon from '../../../../assets/svg/edit.svg?react';
import DownloadIcon from '../../../../assets/svg/download-black.svg?react';
import MoreIcon from '../../../../assets/svg/more.svg?react';
import AddMediaIcon from '../../../../assets/svg/add-to-media_balck.svg?react';
import FJSelectItemsIcon from '../../../../assets/svg/select-items.svg?react';
import { useRef, useState, useCallback, useEffect } from 'react';
import FJUtil from '../../../../util/FJUtil.js';
import classNames from 'classnames';
import FJCheckBox from '../../../../common/components/FJCheckBox/FJCheckBox.jsx';
import FJDropdownNew from '../../../../common/components/FJDropDown/FJDropdownNew.jsx';
import FJDeleteIcon from '../../../../assets/svg/delete-black.svg?react';
import FJAudioPlayManager from '../../../../store/FJAudioPlayManager.js';
import FJConstant from '../../../../constants/FJConstant.js';
import FJTextWithEllipsis from '../../../../common/components/FJTextWithEllipsis/FJTextWithEllipsis.jsx';
import FJLoading from '../../../../common/components/FJLoading/FJLoading.jsx';
import FJAudioWaveImg from '../../../../common/components/FJAudioWave/FJAudioWaveImg.jsx';
import PropTypes from 'prop-types';
import FJAudioTag from '../../../../common/components/FJAudioTag/FJAudioTag.jsx';
import FJToolTip from '../../../../common/components/FJToolTip/FJToolTip.jsx';

const FJAIAudioItem = props => {
    const {
        status,
        audioName,
        audioUrl,
        onRetry,
        onDelete,
        onEdit,
        download,
        preview,
        coverUrl,
        isMultipleMode,
        selected,
        editStatus,
        downloadStatus,
        onSelected,
        id,
        audioWaveImgUrl,
        audioWavePlayImgUrl,
        addToMediaLibrary,
        audioTagType,
        onSelect,
    } = props;
    const [isPlay, setIsPlay] = useState(false);
    const [audioDuration, setAudioDuration] = useState(null);
    const [isCoverError, setIsCoverError] = useState(false);

    const audioRef = useRef(null);
    const isLoading = status === 'progress';
    const isError = status === 'failed';
    const isCompleted = status === 'completed';
    const idRef = useRef(FJAudioPlayManager.createId());

    const updateDuration = useCallback(duration => {
        setAudioDuration(FJUtil.formatTime(duration, false, 2));
    }, []);

    useEffect(() => {
        setIsCoverError(false);
    }, [coverUrl]);

    const _changePlay = e => {
        e.stopPropagation();
        setIsPlay(!isPlay);
        if (isPlay) {
            audioRef.current.pause();
        } else {
            audioRef.current.play();
            FJAudioPlayManager.add(idRef.current, { pause: pause });
        }
    };

    const recordPlay = useCallback(() => {
        FJAudioPlayManager.add(idRef.current, { pause: pause });
    }, []);

    const pause = () => {
        try {
            setIsPlay(false);
            audioRef.current?.pause();
        } catch (e) {
            console.log(e);
        }
    };

    const _renderTrigger = config => {
        return (
            <div onClick={config.onClick} ref={config.ref}>
                <FJButton icon={<MoreIcon />} className={styles.icon_btn} type='white' />
            </div>
        );
    };

    const _renderOverlay = config => {
        return (
            <div className={styles.detail_box} ref={config.ref}>
                <div className={styles.delete_btn} onClick={onSelect}>
                    <FJSelectItemsIcon />
                    {FJLocalStore._('select')}
                </div>
                <div className={styles.delete_btn} onClick={onDelete}>
                    <FJDeleteIcon />
                    {FJLocalStore._('delete')}
                </div>
            </div>
        );
    };

    const forbidEvent = e => {
        FJUtil.forbidEvent(e);
    };

    const _onSelected = (bool, e) => {
        onSelected && onSelected(id, bool, e);
    };

    const onCoverError = () => {
        setIsCoverError(true);
    };

    const _preview = () => {
        preview();
    };

    const _forbidEvent = e => {
        FJUtil.forbidEvent(e);
    };

    return (
        <div className={classNames(styles.box, isMultipleMode ? styles.multiple : null)} onMouseDown={_preview}>
            <div className={styles.left}>
                <div className={styles.control}>
                    {isLoading && (
                        <div className={styles.bk_mask}>
                            <FJAutoLoading shown />
                        </div>
                    )}
                    {isError && (
                        <div className={styles.bk_mask}>
                            <FJErrorIcon />
                        </div>
                    )}
                    {isCompleted && (
                        <>
                            <img className={styles.img} src={coverUrl} onError={onCoverError} alt='' />
                            {isCoverError && (
                                <div className={classNames(styles.bk_mask, styles.cover_error)}>
                                    <FJErrorIcon />
                                </div>
                            )}
                            <div className={styles.play_box} onClick={_changePlay} onMouseDown={_forbidEvent}>
                                {isPlay && <FJPauseIcon />}
                                {!isPlay && <FJPlayIcon />}
                            </div>
                        </>
                    )}
                </div>
                <div className={styles.content}>
                    <div className={styles.header}>
                        <div className={styles.name_and_tag}>
                            <div className={styles.name_box}>
                                <FJTextWithEllipsis className={styles.name} text={audioName} />
                                {isCompleted && (
                                    <FJAudioTag
                                        className={classNames(styles.tag, styles.tag_big)}
                                        type={audioTagType}
                                    />
                                )}
                                {isError && (
                                    <div className={styles.error_text}>
                                        {FJLocalStore._('generation-failed-please-try-again')}
                                    </div>
                                )}
                            </div>
                            {isCompleted && (
                                <FJAudioTag className={classNames(styles.tag, styles.tag_small)} type={audioTagType} />
                            )}
                        </div>

                        {!isMultipleMode && (
                            <div className={classNames(styles.time, styles.time_small)}>{audioDuration}</div>
                        )}
                    </div>

                    {isCompleted && (
                        <>
                            <div className={styles.audio_cover}>
                                <div
                                    className={styles.audio_box}
                                    style={{ display: isMultipleMode ? 'none' : 'block' }}
                                    onClick={forbidEvent}
                                >
                                    <FJAudioWaveImg
                                        audioWaveImgUrl={audioWaveImgUrl}
                                        audioWavePlayImgUrl={audioWavePlayImgUrl}
                                        url={audioUrl}
                                        setIsPlay={setIsPlay}
                                        updateDuration={updateDuration}
                                        recordPlay={recordPlay}
                                        isPlay={isPlay}
                                        ref={audioRef}
                                    />
                                </div>
                            </div>
                            <div className={classNames(styles.time, styles.time_big)}>{audioDuration}</div>
                        </>
                    )}
                </div>
            </div>
            <div className={styles.right} onClick={forbidEvent} onMouseDown={_forbidEvent}>
                {isMultipleMode && !isLoading && <FJCheckBox selected={selected} dataChange={_onSelected} />}
                {isLoading && !isMultipleMode && (
                    <>
                        <div className={styles.loading}>
                            <FJLoading style={{ height: 12, width: 12 }} />
                        </div>
                        <div className={styles.desc}>{FJLocalStore._('generating_')}</div>
                    </>
                )}
                {isError && !isMultipleMode && (
                    <>
                        <FJButton text='retry' className={styles.retry} onClick={onRetry} />
                        <FJDropdownNew
                            isTopLayer={true}
                            renderTrigger={_renderTrigger}
                            useAnchorBody
                            placement='topRight'
                            renderOverlay={_renderOverlay}
                            offsetTop={-8}
                        />
                    </>
                )}
                {isCompleted && !isMultipleMode && (
                    <>
                        <FJToolTip title={window.isEditPage ? 'add-to-media' : 'use-in-a-design'}>
                            <div>
                                <FJButton
                                    icon={window.isEditPage ? <AddMediaIcon /> : <EditIcon />}
                                    className={styles.icon_btn}
                                    onClick={window.isEditPage ? addToMediaLibrary : onEdit}
                                    type='white'
                                    isLoading={editStatus === FJConstant.LOADING}
                                />
                            </div>
                        </FJToolTip>
                        <FJButton
                            icon={<DownloadIcon />}
                            className={styles.icon_btn}
                            type='white'
                            onClick={download}
                            isLoading={downloadStatus === FJConstant.LOADING}
                        />
                        <FJDropdownNew
                            isTopLayer={true}
                            renderTrigger={_renderTrigger}
                            useAnchorBody
                            placement='topRight'
                            renderOverlay={_renderOverlay}
                            offsetTop={-8}
                        />
                    </>
                )}
            </div>
        </div>
    );
};

FJAIAudioItem.propTypes = {
    status: PropTypes.string,
    audioName: PropTypes.string,
    audioUrl: PropTypes.string,
    onRetry: PropTypes.func,
    onDelete: PropTypes.func,
    onEdit: PropTypes.func,
    download: PropTypes.func,
    preview: PropTypes.func,
    coverUrl: PropTypes.string,
    isMultipleMode: PropTypes.bool,
    selected: PropTypes.bool,
    editStatus: PropTypes.string,
    downloadStatus: PropTypes.string,
    onSelected: PropTypes.func,
    id: PropTypes.string,
    audioWaveImgUrl: PropTypes.string,
    audioWavePlayImgUrl: PropTypes.string,
    addToMediaLibrary: PropTypes.func,
};
export default FJAIAudioItem;
